import React from 'react'
import { Link } from 'react-router-dom'

export default function LinkToGallery() {
    return (
        <div>
            <div className="container-fluid pb-3 pt-4" style={{backgroundColor: "#4f575a"}}>
      <div className="container font-monospace text-center align-items-center">
        <Link to="/gallery" className="mylink">
          <h2 className="fw-light">
            <pre>V i s i t  m y  A R T  G A L L E R Y</pre>
          </h2>
        </Link>
      </div>
    </div>
        </div>
    )
}
